module.exports = __webpack_public_path__ + "static/pm-e79f5cd3611aa33936f48a34102e4978.svg";